// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import { MonogramTile } from '@/components/greenlight/MonogramTile';
import { initials } from '@/lib/hueFor';
import { cn } from '@/lib/utils';

// Decorative initials avatar for the apps-list owner column. Delegates to the
// same MonogramTile + initials() path as UserAvatar (Users & RBAC tab) so the
// two surfaces render identical initials for the same person and can't drift.
//
// aria-hidden because the surrounding cell already exposes the owner's email as
// text (and the row carries its own label).
export function OwnerAvatar({
  name,
  email,
  size = 24,
  className,
}: {
  /** Owner display name; drives the initials when present. */
  name?: string | null;
  /** Owner email; the seed for a stable hue and the fallback initial source. */
  email: string;
  size?: number;
  className?: string;
}): React.JSX.Element {
  const displayName = name?.trim();
  // With a name, use first+last initials (matches the Users tab). Without one,
  // fall back to a single initial from the email local part — never the old
  // "local-initial + domain-initial" form.
  const label = displayName ? initials(displayName) : initials(email.split('@')[0] ?? email);
  return (
    <MonogramTile
      seed={displayName || email}
      label={label}
      size={size}
      shape="circle"
      aria-hidden
      className={cn('shrink-0', className)}
    />
  );
}
